// Epics index — reads post-B-117 product epics from `public.tickets`
// (type='epic'). Replaces the legacy GitHub-Projects field-option
// index. Rolls up stories + tasks + bugs per epic for a quick overview.

import { pageBoilerplateFetch } from '../../functions/tickets/ticketUtils.js'
import { fetchEpicsTree } from '../../functions/tickets/fetchEpicsTree.js'

export const epics = {
  extends: 'AppPage',
  metadata: { title: 'Epics / Tickets / Symbols Workspace' },

  fetch: pageBoilerplateFetch,

  onCreate: async (el, s) => {
    const tree = await fetchEpicsTree()
    s.root.update({ epicsTree: tree })
  },

  onRemove: (el) => {
    const root = el.getRoot()
    if (root && root.selectedTicket) root.update({ selectedTicket: null })
  },

  TicketsSidebar: {},
  TicketsEpicsMain: {},
  TicketsNewTicketModal: {},
  TicketsDetailModal: {}
}
